"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstagramApp = exports.isFacebookApp = exports.isWindows = exports.getIOSVersion = exports.isIOS = exports.isIOS11Device = exports.isChromeOnIos = exports.isChrome = exports.getSafariMajorVersion = exports.isSafari = exports.isFirefox = exports.isEdge = exports.isIE = void 0;
/**
 * @deprecated util method.
 * Prefer using feature detection over browser detection when possible.
 * see documentation on documentMode: https://www.geeksforgeeks.org/html-dom-documentmode-property/
 */
var isIE = function (window) {
    // @ts-ignore - documentMode is a feature only in IE
    return !!window && !!window.document && !!window.document.documentMode;
};
exports.isIE = isIE;
/**
 * @deprecated util method.
 * Prefer using feature detection over browser detection when possible.
 * see documentation on edge user agent: https://docs.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-string
 */
var isEdge = function (window) { return getUserAgent(window).indexOf('edg') > -1; };
exports.isEdge = isEdge;
/**
 * @deprecated util method.
 * Prefer using feature detection over browser detection when possible.
 * see documentation on firefox user agent: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent/Firefox
 */
var isFirefox = function (window) { return getUserAgent(window).indexOf('firefox') > -1; };
exports.isFirefox = isFirefox;
/**
 * @deprecated util method.
 * Prefer using feature detection over browser detection when possible.
 * see documentation on safari user agent: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent#Safari_UA_string
 * notice that safari user agent has "Version" directive
 */
var isSafari = function (window) {
    var userAgent = getUserAgent(window);
    return userAgent.indexOf('safari') > -1 && userAgent.indexOf('version') > -1;
};
exports.isSafari = isSafari;
/**
 * @deprecated util method.
 * Prefer using feature detection over browser detection when possible.
 * see documentation on safari user agent: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent#Safari_UA_string
 */
var getSafariMajorVersion = function (window) {
    if ((0, exports.isSafari)(window)) {
        var userAgent = getUserAgent(window);
        var version = userAgent.split(' ');
        version = version.find(function (directive) { return directive.startsWith('version/'); });
        version = version.split('/')[1];
        return parseInt(version, 10);
    }
    return -1;
};
exports.getSafariMajorVersion = getSafariMajorVersion;
/**
 * @deprecated util method.
 * Prefer using feature detection over browser detection when possible.
 * see documentation on chrome user agent: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent#chrome_ua_string
 */
var isChrome = function (window) { return getUserAgent(window).indexOf('chrome') > -1; };
exports.isChrome = isChrome;
/**
 *
 * Chrome on ios user agent https://developer.chrome.com/multidevice/user-agent#chrome_for_ios_user_agent
 */
var isChromeOnIos = function (window) {
    var userAgent = getUserAgent(window);
    return userAgent.indexOf('safari') > -1 && userAgent.indexOf('crios') > -1;
};
exports.isChromeOnIos = isChromeOnIos;
var getUserAgent = function (window) {
    return window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent.toLowerCase() : '';
};
var getPlatform = function (window) { return (window && window.navigator && window.navigator.platform) || ''; };
var isIOS11Device = function (window) {
    var userAgent = getUserAgent(window);
    return /ip(hone|od|ad).*os 11/.test(userAgent);
};
exports.isIOS11Device = isIOS11Device;
var isIOS = function (window) {
    var platform = getPlatform(window);
    return !!platform && /iPad|iPhone|iPod/.test(platform);
};
exports.isIOS = isIOS;
var getIOSVersion = function (window) {
    var userAgent = getUserAgent(window);
    var iOSRegex = /(iphone|ipod|ipad).*os (\d+)_/;
    if (!iOSRegex.test(userAgent)) {
        return NaN;
    }
    var iOSgroups = userAgent.match(iOSRegex);
    return iOSgroups && Number(iOSgroups[2]);
};
exports.getIOSVersion = getIOSVersion;
var isWindows = function (window) {
    var userAgent = getUserAgent(window);
    return !!userAgent && /.*\(win.*\).*/i.test(userAgent);
};
exports.isWindows = isWindows;
var isFacebookApp = function (window) {
    var userAgent = getUserAgent(window);
    return userAgent.includes('fban') || userAgent.includes('fbav');
};
exports.isFacebookApp = isFacebookApp;
var isInstagramApp = function (window) {
    var userAgent = getUserAgent(window);
    return userAgent.includes('instagram');
};
exports.isInstagramApp = isInstagramApp;
//# sourceMappingURL=deprecatedBrowserUtils.js.map